
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import { IProjectCustomField } from '@/utils/types'

@Options({
  components: { TextboxField },
})
export default class Email extends Vue {
  @Prop({ type: Object }) readonly customField!: IProjectCustomField
}
